import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getblog, deleteblog } from '../redux-toolkit/Slice/blogSlice';
import { BASE_URL, DELETE_blog, GET_blog } from '../redux-toolkit/ApiEndpoint';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BlogListPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { blogdata, isLoading } = useSelector(state => state.blog);

    useEffect(() => {
        dispatch(getblog({ endpoint: GET_blog }));
    }, [dispatch]);

    const handleDelete = (uuid) => {
        console.log(uuid, "uuid delete");
        try {
            dispatch(deleteblog({
                endpoint: DELETE_blog, uuid
            })).unwrap();
            toast.success('Blog Delete successfully!');
        } catch (error) {
            toast.error(error || 'Failed to Delete Blog. Please try again.');
        }
    };

    return (
        <main className="page-padding">
            <ToastContainer />
            <section className="product-tab-wrapper">
                <div className="container-fuild">
                    <div className="row position-relative">
                        <div className="d-flex justify-content-between align-items-center flex-wrap ">
                            <h2 className="title">Blog</h2>
                            <button className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase border border-0" onClick={() => navigate('/blog-edit')}>
                                Create Blog
                            </button>
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                    {/* {isError && <p className="text-danger">Error: {isError}</p>} */}
                    <div className="col-lg-12">
                        <div className="right-tab" data-aos="fade-in" data-aos-duration="3000">
                            <div className="product-content table-responsive">
                                {isLoading ? (
                                    <p>Loading...</p>
                                ) : (
                                    <table className="table table-bordered pro-table w-100">
                                        <thead>
                                            <tr>
                                                <th>sr</th>
                                                <th>Blog image</th>
                                                <th>Blog Title</th>
                                                <th>Blog Content</th>
                                                <th>Edit/Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {blogdata && blogdata.length > 0 ? blogdata.map((blog, index) => (
                                                <tr key={blog.uuid}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <img src={BASE_URL + blog.image} alt={blog.title} style={{ width: '80px', height: 'auto' }} />
                                                    </td>
                                                    <td>{blog.title.substring(0, 20)}...</td>
                                                    <td>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: blog.content.length > 50 ? blog.content.substring(0, 50) + '...' : blog.content
                                                            }}
                                                        />
                                                    </td>

                                                    <td>
                                                        <button className="edit-btn border border-0" onClick={() => navigate(`/blog-edit?edit=${blog.uuid}`)}>
                                                            Edit
                                                        </button>
                                                        <button className="delete-btn border border-0" onClick={() => handleDelete(blog.uuid)}>
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="5">No blogs available.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default BlogListPage;


